<template>
  <app-logged>
    <v-flex xs12>
      <app-widget
        actions
        class-widget="md6 offset-md3 sm8 offset-sm2 xs12"
      >
        <div slot="widget-content">
          <AppFormHeader
            title="Informações gerais"
            icon="description"
          />
          <AppVisitaTable />
          <div class="mt-6">
            <AppFormHeader
              title="Ações disponíveis"
              icon="settings"
            />
            <v-list two-line>
              <template v-if="!visita.balancete">
                <v-alert
                  v-if="visita.balancete_nao_requerido"
                  border="left"
                  colored-border
                  type="info"
                  elevation="2"
                >
                  Visita dispensada do envio de balancete
                </v-alert>
                <v-list-item
                  @click="goToImportBalancete"
                  v-if="!visita.balancete_nao_requerido"
                >
                  <v-list-item-avatar>
                    <v-avatar
                      color="info"
                      size="40"
                    >
                      <v-icon dark>
                        poll
                      </v-icon>
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="`Informar balancete`" />
                    <v-list-item-subtitle
                      v-text="
                        `Toque aqui para carregar o balancete desta visita`
                      "
                    />
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon color="secondary lighten-1">
                      cloud_upload
                    </v-icon>
                  </v-list-item-action>
                </v-list-item>
                <v-list-item @click="goToEditVisita">
                  <v-list-item-avatar>
                    <v-avatar
                      color="warning"
                      size="40"
                    >
                      <v-icon dark>
                        edit
                      </v-icon>
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="`Editar visita`" />
                    <v-list-item-subtitle
                      v-text="
                        `Altere as informações deta visita`
                      "
                    />
                  </v-list-item-content>
                </v-list-item>
                <v-list-item @click="goToRemoveVisita">
                  <v-list-item-avatar>
                    <v-avatar
                      color="error"
                      size="40"
                    >
                      <v-icon dark>
                        remove
                      </v-icon>
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="`Remover visita`" />
                    <v-list-item-subtitle
                      v-text="`Toque aqui para excluir esta visita`"
                    />
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-list-item
                v-else
                @click="goToBalancete"
              >
                <v-list-item-avatar>
                  <v-avatar
                    color="success"
                    size="40"
                  >
                    <v-icon dark>
                      poll
                    </v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="`Abrir balancete`" />
                  <v-list-item-subtitle
                    v-text="`Toque aqui para exibir o balancete desta visita`"
                  />
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn
                    icon
                    @click.stop="goToRemoveBalancete"
                  >
                    <v-icon color="error lighten-1">
                      remove
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </div>
      </app-widget>
    </v-flex>
  </app-logged>
</template>
<script>
import AppLogged from '@/components/layouts/AppLogged'
import { mapGetters, mapActions } from 'vuex'
import AppWidget from '@/components/AppWidget'
import AppFormHeader from '@/components/AppFormHeader'
import AppVisitaTable from '@/components/AppVisitaTable'
export default {
  components: {
    AppLogged,
    AppWidget,
    AppFormHeader,
    AppVisitaTable
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters(['visita'])
  },
  methods: {
    ...mapActions(['deleteBalancete', 'deleteVisita']),
    goToImportBalancete () {
      if (!this.visita.balancete) {
        this.$router.push({
          name: 'balancetes-importar-index',
          params: {
            id: this.visita.id
          }
        })
      }
    },
    goToVisitaIndex () {
      this.$router.push({
        name: 'visitas-index'
      })
    },
    goToRemoveVisita () {
      if (confirm('Confirme a exclusão desta visita.')) {
        this.deleteVisita().then(res => {
          this.goToVisitaIndex()
        })
      }
    },
    goToEditVisita () {
      if (!this.visita.balancete) {
        this.$router.push({
          name: 'visitas-update',
          params: {
            id: this.visita.id
          }
        })
      }
    },
    goToRemoveBalancete () {
      if (
        !!this.visita.balancete &&
        confirm('Confirme a exclusão deste balancete')
      ) {
        this.deleteBalancete({
          id: this.visita.balancete.id
        }).then(() => {
          alert('Balancete removido com sucesso.')
          return this.$router.go()
        })
      }
    },
    goToBalancete () {
      if (this.visita.balancete) {
        this.$router.push({
          name: 'balancetes-details-index',
          params: {
            id: this.visita.balancete.id
          }
        })
      }
    }
  }
}
</script>
